

import { IEkonomiskAnalysDates } from '../../../../../../AnalysSettingsHandler/AnalysSettingsHandler';
import EDIcon from '../../../../../../../../../../../../BaseComponents/Icon/EDIcon';

interface IProps {
  dates: IEkonomiskAnalysDates | undefined;
  isInterval: boolean;
}

/**
 * Text som visar datumspannet för en referensperiod
 */
const EkonomiskAnalysEditColumnReferencePeriod: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  if (!props.dates) {
    return null;
  }
  const fromYear = props.dates.from.year || undefined;
  const fromMonth = props.dates.from.month || undefined;
  const fromDay = props.dates.from.day;
  const toYear = props.isInterval ? props.dates.to.year : undefined;
  const toMonth = props.isInterval ? props.dates.to.month : undefined;
  const toDay = props.isInterval ? props.dates.to.day : undefined;

  const fromYearString = fromYear ? fromYear.toString() : '';
  const fromMonthString = fromMonth
    ? `-${fromMonth.toString().padStart(2, '0')}`
    : '';
  const fromDayString = fromDay
    ? `-${fromDay.toString().padStart(2, '0')}`
    : '';
  const toYearString = toYear ? `${toYear.toString()}` : '';
  const toMonthString = toMonth
    ? `-${toMonth.toString().padStart(2, '0')}`
    : '';
  const toDayString = toDay ? `-${toDay.toString().padStart(2, '0')}` : '';

  return (
    <>
      <span>Referensperiod: </span>
      <span>
        {fromYearString}
        {fromMonthString}
        {fromDayString}
      </span>
      {toYear && <EDIcon color="inherit" iconType="arrow_right_alt" />}
      <span>
        {toYearString}
        {toMonthString}
        {toDayString}
      </span>
    </>
  );
};

export default EkonomiskAnalysEditColumnReferencePeriod;
